module.exports = __webpack_public_path__ + "static/media/certification.b4ddfc31.png";